import client from '../client';
import endpoints from '../endpoints';

/**
 * 회원 관리 — 관리자 API
 * API_DOCS: 26. 관리자 - 회원
 *
 * GET /api/admin/users          — 회원 목록 (query: role, search, page, size)
 * GET /api/admin/users/{user_id} — 회원 상세
 * PUT /api/admin/users/{user_id}/status — 상태 변경 ({ status: "active"|"inactive" })
 */

/** GET /api/admin/users — 회원 목록 */
export const getMembers = async (params = {}) => {
  const res = await client.get(endpoints.admin.users.list, { params });
  return res.data;
};

/** GET /api/admin/users/:id — 회원 상세 */
export const getMemberById = async (id) => {
  const res = await client.get(endpoints.admin.users.detail(id));
  return res.data;
};

/** PUT /api/admin/users/:id/status — 상태 변경 */
export const updateMemberStatus = async (id, status) => {
  const res = await client.put(endpoints.admin.users.status(id), { status });
  return res.data;
};

/** DELETE /api/admin/users/:id — 회원 삭제 */
export const deleteMember = async (id) => {
  const res = await client.delete(endpoints.admin.users.detail(id));
  return res.data;
};

/** GET /api/admin/users/:id/reservations — 회원별 예약 내역 */
export const getMemberReservations = async (id, params = {}) => {
  const res = await client.get(endpoints.admin.users.reservations(id), { params });
  return res.data;
};

/** GET /api/admin/users/:id/reviews — 회원별 후기 내역 */
export const getMemberReviews = async (id, params = {}) => {
  const res = await client.get(endpoints.admin.users.reviews(id), { params });
  return res.data;
};
